import { Route } from '@angular/router';
import { InventaireEditComponent } from './inventaire-edit.component';

export const InventaireEditRouting: Route = {
  path: "edit-inventaire",
  component: InventaireEditComponent,
  data: {
    breadcrumb: "Gestion de l'inventaire"
  }
}
